import { MEETING_STATUS_CONFIRMED, MEETING_STATUS_PENDING, isMeetingCancelled } from 'common-data-handling';

/**
 * Returns true if the given meeting invite is pending for the given user ID.
 * Not the same as the one in common-data-handling as it only considers one user POV
 *
 * @param {number} userId - The user ID to check.
 * @param {object} meeting - The meeting object to check.
 * @return {boolean} Returns true if the meeting invite is pending for the given user ID, false otherwise.
 */
export function isUserMeetingPending(userId, meeting) {
    return (
        // inviting AND no one confirmed AND at least one is pending
        ((meeting.initiator.id == userId &&
            !meeting.invited?.some((invite) => invite.state == MEETING_STATUS_CONFIRMED) &&
            meeting.invited?.some((invite) => invite.state == MEETING_STATUS_PENDING)) ||
            // invited AND not confirmed or cancelled
            meeting.invited?.some((invite) => invite.user_id == userId && invite.state == MEETING_STATUS_PENDING)) &&
        !isMeetingCancelled(meeting)
    );
}
